import Theme, {ThemeProvider} from '@jetbrains/ring-ui-built/components/global/theme'
import classNames from 'classnames'
import * as React from 'react'
import {useDeferredValue, useLayoutEffect, useSyncExternalStore} from 'react'

import {isNightly} from '../../../utils/featureToggles'

import type {HeaderProps} from './Header'

import styles from './Header.module.css'

const Header = React.lazy(
  () =>
    import(
      /* webpackChunkName: "Header" */
      './Header'
    ),
)

const HeaderLazy = (props: HeaderProps) => {
  const scrollLeft = useSyncExternalStore(
    onStoreChange => {
      document.addEventListener('scroll', onStoreChange)
      return () => document.removeEventListener('scroll', onStoreChange)
    },
    () => document.documentElement.scrollLeft,
  )
  const deferredScrollLeft = useDeferredValue(scrollLeft)
  useLayoutEffect(() => {
    const placeholder = document.getElementById('react-header-placeholder')
    if (!placeholder) {
      return
    }
    placeholder.hidden = true
  }, [])

  return React.useMemo(
    () => (
      <ThemeProvider
        theme={Theme.DARK}
        className={classNames(styles.container, {
          [styles.nightly]: isNightly(),
        })}
        style={{left: -deferredScrollLeft}}
      >
        <React.Suspense fallback={<div data-suspense-fallback />}>
          <Header {...props} />
        </React.Suspense>
      </ThemeProvider>
    ),
    [props, deferredScrollLeft],
  )
}

export default React.memo(HeaderLazy)
